import { getKeyboardEventKeybinding } from '../utils/getKeyboardEventKeybinding';
import useEventListener from './useEventListener';

export function useKeyboardShortcut(keyBinding: string | string[], action: (target: HTMLElement) => void) {
    const handleKeyDown = (event: KeyboardEvent) => {
        // We might be inside a Shadow DOM so we can't use event.target
        const target = event.composedPath()[0];

        if (!(target instanceof HTMLElement)) {
            return;
        }

        // Ignore editable elements
        if (isEditableElement(target)) {
            return;
        }

        if (keyBinding.includes(getKeyboardEventKeybinding(event))) {
            action(target);

            // we do this to avoid side-effects
            // (e.g. prevent the letter 'f' from being typed into the search input field )
            event.preventDefault();
        }
    };

    useEventListener('keydown', handleKeyDown);
}

function isEditableElement(element: HTMLElement): boolean {
    return (
        element instanceof HTMLInputElement ||
        element instanceof HTMLTextAreaElement ||
        element.isContentEditable ||
        element.getAttribute('role') === 'listbox' ||
        element.getAttribute('role') === 'menuitem' ||
        element.getAttribute('aria-haspopup') === 'menu'
    );
}
